<template>
    <transition name="fade">
        <div class="spinner">
            <div class="spinner__inner">
                <div class="spinner__logo">
                    <svg
                        width="31"
                        height="24"
                        viewBox="0 0 31 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1.07984 12.6468L2.11255 12.6468C3.42691 12.6468 4.64738 13.2549 5.3515 14.331C6.10256 15.407 7.04139 17.0912 8.21492 19.8982C10.1395 24.483 14.3173 23.828 16.148 19.3836C18.8706 12.7403 27.6956 12.6468 27.6956 12.6468L29.9018 12.6468C30.512 12.6468 30.9814 12.1789 30.9814 11.5707C30.9814 10.9625 30.512 10.4947 29.9018 10.4947L28.4466 10.4947C27.2261 10.4947 26.0526 9.93331 25.3015 8.95085C24.4566 7.87483 23.377 6.05027 22.1095 3.1029C20.185 -1.4351 16.5235 -0.780134 14.7398 3.66431C12.0641 10.3544 3.28608 10.4947 3.28608 10.4947L1.07984 10.4947C0.469604 10.4947 0.000191791 10.9625 0.000191738 11.5707C0.000191684 12.1789 0.469603 12.6468 1.07984 12.6468Z"
                            fill="#22d0a9"
                        />
                    </svg>
                </div>
                <div v-if="text" class="spinner__text">
                    {{ text }}
                </div>
                <div v-else class="spinner__text">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Spinner',
    props: {
        text: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" src="./Spinner.scss"></style>
